import React from "react";

export const Press = () => {
  return (
    <section
      id="press"
      data-testid="press-section"
      className="py-20 md:py-28 border-t border-b border-black/10 bg-[#F7F7F6]"
    >
      <div className="px-6 md:px-10 grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-3">
          <div className="font-mono-label text-[11px] text-black/55">
            § 07 · In the press
          </div>
        </div>

        <div className="col-span-12 md:col-span-9">
          <h2
            data-testid="press-heading"
            className="font-serif-display text-[36px] md:text-[56px] leading-[1.05] tracking-tight"
          >
            Quietly noted by the press that{" "}
            <span className="italic-accent">cares about how software is made.</span>
          </h2>

          <div className="mt-10 pt-6 border-t border-black/10 max-w-[680px]">
            <p
              data-testid="press-placeholder"
              className="font-serif-display italic text-[22px] md:text-[26px] leading-[1.4] text-black/75"
            >
              "Coverage in progress. We are building in public and inviting the
              right journalists to watch."
            </p>
            <div className="mt-6 font-mono-label text-[10px] text-black/45">
              — MERA Editorial · December 2025
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
